import { useSelector } from "react-redux";
import { selectCurrentToken } from "../features/auth/authSlice";
import { jwtDecode } from "jwt-decode";

const useAuth = () => {
  const token = useSelector(selectCurrentToken);
  let isManager = false;
  let isAdmin = false;
  let isOwner = false;
  let status = "Guest";

  if (token) {
    const decoded = jwtDecode(token);
    const { username, picture, roles } = decoded.UserInfo;

    isManager = roles.includes("Manager");
    isAdmin = roles.includes("Admin");
    isOwner = roles.includes("Owner");

    if (isManager) status = "Manager";
    if (isAdmin) status = "Admin";
    if (isOwner) status = "Owner";

    return { username, picture, roles, status, isManager, isAdmin, isOwner };
  }

  return {
    username: "",
    picture: "",
    roles: [],
    isManager,
    isAdmin,
    isOwner,
    status,
  };
};
export default useAuth;
